import styled from "styled-components";
import BenefitBackground from "/public/assets/images/career/benefit/benefit-bg.png"
import BenefitMoBackground from "/public/assets/images/career/benefit/benefit-mo-bg.png"
import {useContext, useEffect, useRef} from "react";
import {LayoutContext} from "@/app/ClientRootHomepage";
import {SIZES} from "@/components/constants";
import {BENEFIT_ITEMS} from "@/app/homepage/career/controller";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { getScroller, setupLenyStyle, refreshOnAssetsReady } from "@/app/homepage/utils";
import {useMediaQuery} from "react-responsive";

gsap.registerPlugin(ScrollTrigger);

const Benefit = () => {
    const { rootRef } = useContext(LayoutContext);
    const wrapRef = useRef(null);
    const isTablet = useMediaQuery({
        query: `(max-width: ${SIZES.TABLET})`
    });

    useEffect(() => {
        const wrap = wrapRef.current;
        if (!wrap) return;
        const scroller = getScroller?.(rootRef) || window;
        const contentEl = scroller?.querySelector?.(".root") || scroller?.firstElementChild || scroller;
        const cleanup = setupLenyStyle ? setupLenyStyle({ wrap, scroller, contentEl }).cleanup : () => {};
        const triggers = [];
        const timelines = [];
        const groups = Array.from(wrap.querySelectorAll(".item-list-wrap"));
        groups.forEach((group) => {
            const cards = Array.from(group.querySelectorAll(".item-inner"));
            if (!cards.length) return;
            gsap.set(cards, { opacity: 0, y: 30, willChange: "transform,opacity" });
            const tl = gsap.timeline({ paused: true })
                .to(cards, {
                    opacity: 1,
                    y: 0,
                    duration: 0.6,
                    ease: "power2.out",
                    stagger: 0.12,
                }, 0);
            const st = ScrollTrigger.create({
                trigger: group,
                start: "top 75%",
                end: "top 45%",
                toggleActions: "play none none reverse",
                onEnter: () => tl.play(),
                onEnterBack: () => tl.play(),
                onLeaveBack: () => tl.reverse(),
            });
            timelines.push(tl);
            triggers.push(st);
        });

        const onResize = () => ScrollTrigger.refresh();
        window.addEventListener("resize", onResize);
        const offAssets = refreshOnAssetsReady ? refreshOnAssetsReady(wrap, () => ScrollTrigger.refresh()) : null;

        return () => {
            triggers.forEach((t) => t.kill());
            timelines.forEach((t) => t.kill());
            window.removeEventListener("resize", onResize);
            offAssets && offAssets();
            cleanup();
        };
    }, [rootRef]);
    return(
        <BenefitWrap ref={wrapRef}>
            <TitleWrap>
                {
                    !isTablet ?

                        <div className={"text-box"}>
                            <h2>Benefit</h2>
                            <p>
                                웅비는 단순한 일터를 넘어, 구성원 한 분 한 분의 삶이 풍요롭고 행복으로 가득 채워질 수 있도록 마음을 다합니다.<br/>
                                당신의 성장을 돕고, 일과 삶의 균형을 지원하며, 가족의 행복까지 생각하는 웅비의 진심을 만나보세요. 이곳에서 당신의 멋진 내일이 시작됩니다.
                            </p>
                        </div>
                        :
                        <div className={"mo-value-box"}>
                            <div className={"box-text-inner"}>
                                <h2>Benefit</h2>
                                <p>
                                    웅비는 단순한 일터를 넘어,<br/>
                                    구성원 한 분 한 분의 삶이 풍요롭고 행복으로<br/>
                                    가득 채워질 수 있도록 마음을 다합니다.<br/>
                                    당신의 성장을 돕고,<br/>
                                    일과 삶의 균형을 지원하며,<br/>
                                    가족의 행복까지 생각하는<br/>
                                    웅비의 진심을 만나보세요.<br/>
                                    이곳에서 당신의 멋진 내일이 시작됩니다.
                                </p>
                            </div>
                            <div className={"box-bg-inner"}>
                                <img src={BenefitMoBackground?.src} alt={"배너 이미지"}/>
                            </div>
                        </div>
                }
            </TitleWrap>
            <ContentWrap>
                {
                    BENEFIT_ITEMS.map((wrap,key)=>
                        <div className={"item-list-wrap"} key={key}>
                            {
                                wrap.items.map((list, key2)=>
                                    <div className={"item-inner"} key={key2}>
                                        <div className={"info"}>
                                            <div className={"item-icon"}>
                                                <img src={list.imageItem} alt={`아이콘 ${key2+1}`}/>
                                            </div>
                                            <div className={"text-box"}>
                                                <p>{list.infoTitle}</p>
                                                <span>{list.infoCont}</span>
                                            </div>
                                        </div>
                                        {
                                            isTablet &&
                                            <div className={"mo-text-box"}>{list.infoCont}</div>
                                        }
                                        <div className={"desc"}>{list.desc}</div>
                                    </div>
                                )
                            }
                        </div>
                    )
                }
            </ContentWrap>
        </BenefitWrap>
    )
}
const ContentWrap = styled.div`
    padding: 80px 0 0;
    max-width: 1280px;
    margin: 0 auto;
    .item-list-wrap{
        & + .item-list-wrap{
            margin-top: 40px;
        }
        display: flex;
        align-items: center;
        gap: 40px;
        .item-inner{
            width: 100%;
            height: 260px;
            border-bottom: 1px solid #E6E6E6;
            .info{
                display: flex;
                gap: 16px;
                .item-icon{
                    width: 64px;
                    flex-shrink: 0;
                }
                .text-box{
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    p{
                        font-weight: 700;
                        font-size: 24px;
                        line-height: 36px;
                        letter-spacing: -0.02em;
                        color: #000000;
                    }
                    span{
                        font-weight: 500;
                        font-size: 18px;
                        line-height: 28px;
                        letter-spacing: -0.02em;
                        color: #4939B1;
                    }
                }
            }
            .desc{
                margin-top: 44px;
                font-weight: 400;
                font-size: 16px;
                line-height: 24px;
                color: #666666;
                white-space: pre-line;
            }
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        padding: 80px 16px 0;
        width: 100%;
        max-width: 100%;
        .item-list-wrap{
            & + .item-list-wrap{
                margin-top: 24px;
            }
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            gap: 24px;
            .item-inner{
                height: auto;
                padding-bottom: 52px;
                .info{
                    align-items: center;
                    .text-box{
                        p{
                            font-weight: 700;
                            font-size: 24px;
                            line-height: 36px;
                            letter-spacing: -0.02em;
                        }
                        span{
                            display: none;
                        }
                    }
                }
                .mo-text-box{
                    font-weight: 500;
                    font-size: 18px;
                    line-height: 28px;
                    letter-spacing: -0.02em;
                    color: #4939B1;
                }
                .desc{
                    font-size: 14px;
                    line-height: 22px;
                    margin-top: 16px;
                }
            }
        }
    }
`
const BenefitWrap = styled.div`
    padding: 60px 0 160px;
    @media (max-width: ${SIZES.TABLET}) {
        padding: 40px 0 160px;
    }
`

const TitleWrap = styled.div`
    padding: 0 114px 80px;

    .text-box {
        border-radius: 20px;
        overflow: hidden;
        background: url(${BenefitBackground?.src}) no-repeat center / cover;
        height: 400px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 0 20px;

        h2 {
            font-weight: 700;
            font-size: 48px;
            line-height: 58px;
            text-align: center;
            letter-spacing: -0.02em;
            color: #FFFFFF;
            margin-bottom: 16px;
        }
        p{
            font-weight: 400;
            font-size: 24px;
            line-height: 36px;
            text-align: center;
            letter-spacing: -0.02em;
            color: #E6E6E6;
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        padding: 0 0 80px;
        .mo-value-box{
            .box-text-inner{
                text-align: center;
                margin-bottom: 40px;
                h2{
                    font-weight: 700;
                    font-size: 24px;
                    line-height: 36px;
                    letter-spacing: -0.02em;
                    color: #4939B1;
                    margin-bottom: 40px;
                }
                p{
                    font-weight: 400;
                    font-size: 18px;
                    line-height: 28px;
                    color: #666666;
                }
            }
        }
    }
`
export default Benefit